import { Controller } from '@hotwired/stimulus'
import { formatText, loadPreferences } from '../utils/text_formatter'
import { preloadOpenCC } from '../utils/text_formatter/opencc_loader'

/**
 * 格式調整器的 Stimulus controller（精簡版）。
 *
 * 只負責 input → format → output 和複製功能。
 * toggle/偏好管理已委派給 formatter_settings_controller.js。
 * 透過監聽 'formatter-settings:changed' custom event 自動重新格式化。
 */
export default class extends Controller {
  static targets = ['input', 'output', 'copyButton', 'copyText', 'applyToInputButton', 'applyToInputText']

  connect() {
    this.enabledIds = loadPreferences()
    this._debounceTimer = null
    // 背景載入 opencc-js（簡繁轉換），載入完成後自動 re-format
    preloadOpenCC().then(() => this.format()).catch(() => {})
  }

  disconnect() {
    if (this._debounceTimer) clearTimeout(this._debounceTimer)
  }

  /** 格式化（debounce 150ms），由 input 變更和 settings changed 事件觸發 */
  format() {
    if (this._debounceTimer) clearTimeout(this._debounceTimer)
    this._debounceTimer = setTimeout(() => {
      // 每次格式化前重新載入偏好，確保 settings controller 的變更被反映
      this.enabledIds = loadPreferences()
      this._applyFormat()
    }, 150)
  }

  /** 複製結果到剪貼簿 */
  copy() {
    const text = this.outputTarget.value
    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      this.copyTextTarget.textContent = '已複製'
      setTimeout(() => {
        this.copyTextTarget.textContent = '複製'
      }, 1500)
    })
  }

  /** 將結果填入原文區，觸發重新格式化（用於多輪格式化場景） */
  applyToInput() {
    const text = this.outputTarget.value
    if (!text) return

    this.inputTarget.value = text
    this.format()

    this.applyToInputTextTarget.textContent = '已填入'
    setTimeout(() => {
      this.applyToInputTextTarget.textContent = '結果填入原文'
    }, 1500)
  }

  // === Private ===

  _applyFormat() {
    const text = this.inputTarget.value
    const result = formatText(text, this.enabledIds)
    this.outputTarget.value = result
  }
}
